import ModuleRichText from './ModuleRichText';

export default ModuleRichText;
export * from './ModuleRichText';
